import { put } from 'redux-saga/effects';
import { getShowDetailsById } from '../../api/showAPI';
import * as types from './showActionTypes';

export function* showSaga() {
  try {
    const record = yield getShowDetailsById();
    if (record && record.error) {
      yield put({
        type: types.GET_SHOW_ERROR,
        error: record.error,
      });
    } else {
      yield put({
        type: types.GET_SHOW_SUCCESS,
        show: record[0],
      });
    }
  } catch (error) {
    yield put({
      type: types.GET_SHOW_ERROR,
      error,
    });
  }
}



// WEBPACK FOOTER //
// ./src/store/show/showSaga.js